export default "__VITE_ASSET__CT92rVm5__"